import { computed, inject, Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { UrlSegment } from './types'

const UUID_REGEX = new RegExp('[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}', 'gi')

@Injectable({ providedIn: 'root' })
export class UrlIdSplitterService {
  private readonly router = inject(Router)

  private readonly url = computed(() => {
    this.router.lastSuccessfulNavigation()
    return this.router.url
  })

  readonly segments = computed<UrlSegment[]>(() => {
    const url = this.url()
    const segments: UrlSegment[] = []
    let cursor = 0

    for (const match of url.matchAll(UUID_REGEX)) {
      const id = match[0]
      const start = match.index

      if (start > cursor) {
        segments.push({ type: 'text', text: url.slice(cursor, start) })
      }

      segments.push({ type: 'id', id })

      cursor = start + id.length
    }

    if (cursor < url.length) {
      segments.push({ type: 'text', text: url.slice(cursor) })
    }

    return segments
  })
}
